<template>
  <section class="signature">
    <div class="signatureBox">
      <div class="toptitle">
      <span class="return">
        <!--<router-link tag="span" to="/orderlist?source=source">&lt;</router-link>-->
        <span v-if="$route.query.back" @click="go_back">&lt;</span>
      </span>
        訂單簽名
        <span>{{orderlist.quotation_code}}</span>
      </div>
      <!--<div class="title">訂單 {{orderlist.quotation_code}} 簽署</div>-->
      <div class="canvasBox" ref="canvasHW">
        <canvas @touchstart='touchStart'
                @touchmove='touchMove'
                @touchend='touchEnd'
                ref="canvasF"
                @mousedown="mouseDown"
                @mousemove="mouseMove"
                @mouseup="mouseUp"></canvas>
        <div class="btnBox">
          <mt-button
            type="primary"
            size="small"
            @click="overwrite"
          >重写
          </mt-button>

          <mt-button
            size="small"
            type="primary"
            @click="commit"
          >
              提交签名
          </mt-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  // import ImageCompressor from 'image-compressor.js'
  import { MessageBox,Button  } from 'mint-ui';
  import { commitOrderEdit,upload_electronic_signature } from '../assets/js/api';
  export default {
    name: "signature",
    data() {
      return {
        client: {},
        points: [],
        canvasTxt: null,
        startX: 0,
        startY: 0,
        moveY: 0,
        moveX: 0,
        endY: 0,
        endX: 0,
        w: null,
        h: null,
        isDown: false,
        isViewAutograph: this.$route.query.isViews > 0,
        contractSuccess: this.$route.query.contractSuccess,
        orderlist:{}
      }
    },
    mounted() {
      // console.log(this.$route.query.id)
      commitOrderEdit(this.$route.query.id).then(data=>{
        // console.log(data)
        this.orderlist = data
        this.$store.commit('set_signature_status',data.electronic_signature_status) //签名状态
      })
      let canvas = this.$refs.canvasF
      // 手機頁面
      // if(this.$store.state.client){
      //   canvas.height = this.$refs.canvasHW.offsetHeight - 200
      //   canvas.width = this.$refs.canvasHW.offsetWidth - 30
      // }
      // else {
      //   canvas.height = this.$refs.canvasHW.offsetHeight - 320
      //   canvas.width = this.$refs.canvasHW.offsetWidth - 20
      // }
      canvas.height = this.$refs.canvasHW.offsetHeight - 300
      canvas.width = this.$refs.canvasHW.offsetWidth - 20
      this.canvasTxt = canvas.getContext('2d')
    },
    methods: {
      //电脑设备事件
      mouseDown(ev) {
        ev = ev || event
        ev.preventDefault()
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.isDown = true
          this.imgUrl =
            (this.$refs.canvasF && this.$refs.canvasF.toDataURL()) || ''
        }
      },
      mouseMove(ev) {
        ev = ev || event
        ev.preventDefault()
        if (this.isDown) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      mouseUp(ev) {
        ev = ev || event
        ev.preventDefault()
        if (1) {
          let obj = {
            x: ev.offsetX,
            y: ev.offsetY
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.points.push({x: -1, y: -1})
          this.isDown = false
        }
      },

      //移动设备事件
      touchStart(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.startX = obj.x
          this.startY = obj.y
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
        }
      },
      touchMove(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.moveY = obj.y
          this.moveX = obj.x
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.startY = obj.y
          this.startX = obj.x
          this.points.push(obj)
        }
      },
      touchEnd(ev) {
        ev = ev || event
        ev.preventDefault()
        if (ev.touches.length == 1) {
          let obj = {
            x: ev.targetTouches[0].clientX - 10,
            y: ev.targetTouches[0].clientY - 65
          }
          this.canvasTxt.beginPath()
          this.canvasTxt.lineWidth= "5";
          this.canvasTxt.strokeStyle= "#000";
          this.canvasTxt.moveTo(this.startX, this.startY)
          this.canvasTxt.lineTo(obj.x, obj.y)
          this.canvasTxt.stroke()
          this.canvasTxt.closePath()
          this.points.push(obj)
          this.points.push({x: -1, y: -1})
          this.imgUrl =
            (this.$refs.canvasF && this.$refs.canvasF.toDataURL()) || ''
        }
      },
      // 返回
      go_back(){
        this.$router.go(-1)
      },
      //重写
      overwrite() {
        this.canvasTxt.clearRect(
          0,
          0,
          this.$refs.canvasF.width,
          this.$refs.canvasF.height
        )
        this.points = []
      },
      //提交签名
      commit() {
        // 订单状态已签署不能提交订单
        if (this.orderlist.quotation_ifshow !== '1'){
          if (this.$store.state.client){
            MessageBox({
              title: '提示',
              message: '已签署订单不能修改',
            }).then(()=>{
            });
          }
          else {
            this.$alert('已签署订单不能修改', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        }
        else {
          upload_electronic_signature({
            id : this.$route.query.id,
            file_base : this.$refs.canvasF.toDataURL(),
          }).then(data=>{
            // console.log(data)
            if (data.status){
              this.$store.commit('set_signature_status',1)
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  message: '提交成功',
                }).then(()=>{
                  if (this.$route.query.back){
                    this.go_back()
                  }
                });
              }
              else {
                this.$alert('提交成功', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                    if (this.$route.query.back){
                      this.go_back()
                    }
                  }
                });
              }
            }
            else {
              if (this.$store.state.client){
                MessageBox({
                  title: '提示',
                  message: '提交失败',
                }).then(()=>{
                });
              }
              else {
                this.$alert('提交失败', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
            }
          })
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/less/base";
  .signatureBox {
    /*position : absolute;*/
    top: 50px;
    left: 0px;
    width: 100%;
    /*height: 500px;*/
    height: calc(100% - 20px);
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    z-index: 100;
    display: flex;
    flex-direction: column;
    .toptitle{
      /*position: fixed;*/
      z-index: 1;
      width: 90%;
      background-color: @maincolor;
      height: 52px;
      font-size: 16px;
      line-height: 52px;
      color: #fff;
      box-shadow: 0px 2px 5px 2px #e8e8e8;
      text-align: center;
      display: flex;
      justify-content: space-between;
      padding: 0 5%;
      img{
        height: 46px;
      }
      .return{
        font-size: 40px;
        cursor: pointer;
      }
    }
    .title{
      padding: 30px;
      text-align: center;
      font-size: 30px;
    }
  }

  .visaDetailTop {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    z-index: 2;
  }

  .visaDetailTop p {
    margin: 0px;
    text-align: center;
    color: #000;
    font-size: 1em;
    position: relative;
  }

  p.visaTitle {
    width: 100%;
    position: absolute;
    top: 5px;
    left: 0px;
    text-align: center;
    font-size: 1.2em;
  }

  .btnBack {
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: transparent;
    border-color: transparent;
    outline: none;
  }

  .btnDaoHang {
    display: block;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 2.2em;
    width: 2em;
    z-index: 1;
    background: transparent;
    border-color: transparent;
    outline: none;
  }

  .visaDetailTop p span {
    color: #fff;
    font-size: 1.2em;
  }

  .visaDetailTop p:first-of-type {
    float: left;
  }

  .visaDetailTop p:nth-of-type(2) {
    float: right;
  }

  .canvasBox {
    padding: 10px 5px;
    box-sizing: border-box;
    flex: 1;
  }

  canvas {
    /*height: 300px;*/
    border: 1px solid #e3e3e3;
    width: 100%;
  }

  .btnBox {
    padding: 5px;
    margin-top: 20px;
    text-align: right;
    display: flex;
    justify-content: center;
    button{
      margin-left: 20px;
      cursor: pointer;
    }
  }

  @media only screen and (min-width: 750px) {
      .signatureBox {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      overflow: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/signature.vue